import { DropdownStyles } from "@fluentui/web-components";
import { css } from "@microsoft/fast-element";
export const styles = css `
  ${DropdownStyles}
  ::slotted([popover]) {
    position: fixed;
  }
`;
//# sourceMappingURL=dropdown.styles.js.map